<template>
	<el-dialog
		class="modal-batch-stores"
		:title="title"
		:visible.sync="visible"
		@close="$_cancle"
		lock-scroll
		append-to-body
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<div class="content">
			<el-form
				ref="batchStores"
				:rules="rules"
				v-loading="isLoading"
				label-position="right"
				:model="formData"
				@submit.native.prevent
				class="batch-stores__form"
			>
				<el-form-item label="所属品牌:" prop="brandName">
					<el-input
						:disabled="true"
						v-model="formData.brandName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button @click="$_selectBrand" class="select__btn">选择</el-button>
				</el-form-item>

				<el-form-item label="供应商订阅名称:" prop="accessName">
					<el-input
						:disabled="true"
						v-model="formData.accessName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button @click="$_selectAccess" class="select__btn"
						>选择</el-button
					>
				</el-form-item>

				<el-form-item label="骑手平台:" prop="sysName">
					<el-input
						:disabled="true"
						v-model="formData.sysName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button @click="$_selectSys" class="select__btn">选择</el-button>
				</el-form-item>

				<el-form-item label="骑手账号标识:" prop="identifying">
					<el-input
						v-model="formData.identifying"
						placeholder="不填则表示默认骑手标识"
						style="width: 291px"
					></el-input>
				</el-form-item>

				<el-form-item
					label="接收结果邮箱:"
					prop="emails"
					type="textarea"
					style="margin-bottom: 0"
				>
					<el-input
						type="textarea"
						style="width: 366px; height: 100px"
						resize="none"
						placeholder="必填"
						v-model="formData.emails"
						@blur="inpEmail"
					></el-input>
					<div class="input-tips">*最多输入20个邮箱地址, 多个用", "隔开</div>
				</el-form-item>

				<el-form-item label>
					<span>请下载批量导入模板, 编辑后选择对应导入文件点击"上传"生成</span>
					<el-button @click="$_download" class="select__btn"
						>下载导入模板</el-button
					>
				</el-form-item>

				<el-form-item label prop="filename">
					<label for="upload">
						<span
							v-show="formData.filename === ''"
							class="filename__span el-input__inner placeholder"
							>上传的文件, 仅支持*.xls或*.xlsx的文件类型</span
						>
						<span
							v-show="formData.filename !== ''"
							class="filename__span el-input__inner"
							>{{ formData.filename }}</span
						>

						<input
							type="file"
							ref="fileInput"
							@change="$_selectFile"
							name="upload"
							id="upload"
							accept=".xls, .xlsx"
							style="display: none"
						/>
						<span class="select-btn__span">选择文件</span>
					</label>
					<el-button @click="$_upload" class="select__btn">上传</el-button>
					<div class="tips-txt">
						*如导入文件中存在已有门店ID, 系统自动更新对应的门店名称
					</div>
				</el-form-item>
			</el-form>
		</div>

		<div slot="footer" class="dialog-footer">
			<!-- <el-button class="save__btn" @click="$_submit">保存</el-button> -->
			<el-button class="cancel__btn" @click="$_cancle">放弃</el-button>
		</div>

		<select-brand
			v-if="modal.show === true && modal.template === 'select-brand'"
			:title="modal.title"
			:selected="modal.data"
			@callback="$_callbackBrand"
			@close="$_close"
		></select-brand>

		<!-- 选择供应商订阅弹窗组件 -->
		<select-access
			v-if="modal.show === true && modal.template === 'select-access'"
			:title="modal.title"
			:selected="formData.accessKey"
			:accessList="modal.data"
			:showBrandName="true"
			@callback="$_callbackAccess"
			@close="$_close"
		></select-access>

		<!-- 选择骑手平台弹窗组件 -->
		<select-sys
			v-if="modal.show === true && modal.template === 'select-sys'"
			:title="modal.title"
			:selected="modal.data"
			@callback="$_callbackSys"
			@close="$_close"
		></select-sys>
	</el-dialog>
</template>
<script>
import XLSX from 'xlsx'
import * as Utils from '@/plugins/utils'
import SelectBrand from '@/components/modal-select-brand'
import SelectAccess from '@/components/modal-select-access'
import SelectSys from '@/components/modal-select-riderCompany'

export default {
	name: 'modal-modify-store',
	props: {
		title: { type: String, default: '' }
	},
	data() {
		return {
			visible: false,
			isLoading: false,
			formData: {
				emails: '',
				filename: '',
				accessName: '',
				sysName: '',
				importStoreMappingList: [],
				mid: -1,
				platformKey: '', // 根据已选品牌取值
				platformName: '', // 根据已选品牌取值
				brandId: 0, // 根据已选品牌取值
				brandName: '', // 根据已选品牌取值
				brand: {}, // 已选品牌对象
				accessKey: '',
				accessName: '',
				sysName: '',
				sysType: '',
				mappingId: '',
				identifying: ''
			},
			modal: {
				show: false,
				title: '',
				template: '',
				data: {}
			},
			rules: {
				brandName: [{ required: true, message: '请选择所属品牌' }],
				accessName: [
					{ required: true, message: '请选择供应商订阅名称', trigger: 'blur' }
				],
				sysName: [
					{ required: true, message: '请选择骑手平台', trigger: 'blur' }
				],
				emails: [
					{ required: true, message: '请输入邮箱地址' },
					{
						validator: (rule, value, callback) => {
							if (value) {
								if (value.match(/\w.*,{2,}/) || value.match(/^[,].*/)) {
									callback(new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`))
								} else {
									let emails = value.split(',').filter(email => email != '')
									if (emails.length > 20) {
										callback(new Error(`最多可输入20个邮箱地址!`))
									}
									const reg =
										/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

									let hasError = emails.some(item => {
										return item.replace(/\s*/, '').match(reg) === null
									})

									if (hasError) {
										callback(
											new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`)
										)
									} else {
										callback()
									}
								}
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				filename: [{ required: true, message: '请上传需要导入的文件' }]
			}
		}
	},
	computed: {
		aid(){
			return this.$store.getters.aid||''
		}
	},
	watch: {
		'formData.brand'(val, oldVal) {
			this.formData.platformKey = val.platformKey || ''
			this.formData.platformName = val.platformName || ''
			this.formData.brandId = val.brandId || 0
			this.formData.brandName = val.brandName || ''
			if (Object.keys(oldVal).length > 0) {
				this.formData.accessKey = ''
				this.formData.accessName = ''
			}
		}
	},
	methods: {
		//缓存上一次选择的数据
		$_setLoaclData() {
			let { brand, accessKey, accessName, emails } = this.formData
			const { platformName, platformKey, brandId, brandName } = brand || {}

			Utils.data.set('horsemanImportMapping'+this.aid, {
				platformName,
				platformKey,
				brandId,
				brandName,
				emails,
				accessKey,
				accessName
			})
		},
		inpEmail(){
			this.$_setLoaclData()
		},
		$_selectBrand() {
			// 处理已选择的品牌数据
			this.modal.data = JSON.parse(JSON.stringify(this.formData.brand))
			this.modal.title = '选择品牌'
			this.modal.template = 'select-brand'
			this.modal.show = true
		},
		// 选择品牌回调
		$_callbackBrand(data) {
			this.formData.brand = { ...data }
			this.$refs['batchStores'].validateField('brandName')

			this.$_setLoaclData()
		},
		// 关闭选择品牌
		$_close() {
			this.modal.show = false
			this.modal.template = ''
			this.modal.title = ''
			this.modal.data = {}
		},
		// 选择供应商订阅
		async $_selectAccess() {
			if (this.formData.brandId === 0) {
				$MessageBox.alert({ content: '请选择品牌' })
				return false
			}
			await this.$service
				.post('findSubscribeByPlatform', {
					platformKey: this.formData.platformKey
				})
				.then(result => {
					this.isLoading = false
					if (result.$.checkResult(result, true)) {
						this.modal.data = result.data.reduce((prev, next) => {
							const list =
								next.accessList.map(item => {
									item.brandName = next.brandName
									return item
								}) || []
							return prev.concat(list)
						}, [])
					}
				})
			this.modal.title = '选择供应商订阅名称'
			this.modal.template = 'select-access'
			this.modal.show = true
		},
		// 选择供应商订阅回调
		$_callbackAccess(data) {
			this.formData.accessKey = data.accessKey
			this.formData.accessName = data.accessName
			this.$refs['batchStores'].validateField('accessName')

			this.$_setLoaclData()
		},

		// 选择骑手平台
		$_selectSys() {
			this.modal.data = {
				sysType: this.formData.sysType,
				sysName: this.formData.sysName
			}
			this.modal.title = '选择骑手平台'
			this.modal.template = 'select-sys'
			this.modal.show = true
		},
		// 选择骑手平台回调
		$_callbackSys(data) {
			let { deliverySysType, deliverySysName } = data
			this.formData.sysType = deliverySysType
			this.formData.sysName = deliverySysName
			// this.$refs["modifyMapping"].validateField("sysName");
		},

		// 下载模板
		$_download() {
			const DATA = [['门店ID', '映射ID']]
			const ws = XLSX.utils.aoa_to_sheet(DATA)
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, '门店列表')
			XLSX.writeFile(wb, '门店列表.xlsx')
		},
		$_clearSelectedFile() {
			this.$refs['fileInput'].value = ''
			this.formData.filename = ''
			this.formData.importStoreMappingList.splice(0)
		},
		// 选择文件
		$_selectFile(event) {
			const self = this
			const files = event.target.files
			if (!files || files.length === 0) return false
			const file = files[0]
			const filename = file.name
			let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, '$2')

			if (!~['xls', 'xlsx', 'XLS', 'XLSX'].indexOf(fileType)) {
				$MessageBox.alert({
					content: '文件格式错误!',
					onOk() {
						self.$_clearSelectedFile()
					}
				})
				return false
			}
			let fileSize = file.size / 1024 / 1024
			if (fileSize > 1) {
				$MessageBox.alert({
					content: '文件大小不能超过1MB!',
					onOk() {
						self.$_clearSelectedFile()
					}
				})
				return false
			}
			const reader = new FileReader()
			reader.onload = e => {
				const bstr = e.target.result
				try {
					XLSX.read(bstr, { type: 'binary' })
				} catch (error) {
					$MessageBox.alert({
						content: '读取文件失败!',
						onOk() {
							self.$_clearSelectedFile()
						}
					})
					return false
				}
				const wb = XLSX.read(bstr, { type: 'binary' })

				const wsname = wb.SheetNames[0]
				const ws = wb.Sheets[wsname]
				const data = XLSX.utils.sheet_to_json(ws, { header: 1 })

				const header = data[0].concat([])

				if (
					header.length !== 2 ||
					header[0] !== '门店ID' ||
					header[1] !== '映射ID'
				) {
					$MessageBox.alert({
						content: '文件数据格式有误!',
						onOk() {
							self.$_clearSelectedFile()
						}
					})
					return false
				}
				this.formData.filename = filename
				// this.$refs['batchStores'].validate();
				data.shift()

				this.formData.importStoreMappingList = data.map(item => {
					if (typeof item[0] === 'undefined') {
						item[0] = ''
					}
					if (typeof item[1] === 'undefined') {
						item[1] = ''
					}
					return {
						mappingId: item[1],
						storeId: item[0]
					}
				})
			}
			reader.readAsBinaryString(file)
		},
		// 点击上传按钮
		$_upload() {
			this.$refs['batchStores'].validate(valid => {
				if (valid) {
					const self = this

					if (
						this.formData.filename !== '' &&
						this.formData.importStoreMappingList.length > 0
					) {
						let {
							accessKey,
							sysType,
							brandId,
							emails,
							importStoreMappingList,
							identifying
						} = this.formData
						let emailsArr = emails.split(',')
						this.isLoading = true
						this.$service
							.post('batchstoreMapping', {
								accessKey,
								sysType,
								type: 1,
								emails: emailsArr,
								importStoreMappingList,
								brandId,
								identifying: identifying || null
							})
							.then(result => {
								if (result.$.checkResult(result, true)) {
									$MessageBox.alert({
										content: result.msg,
										onOk() {
											self.$_clearSelectedFile()
										}
									})
								}
								this.isLoading = false
							})
					} else {
						$MessageBox.alert({ content: '请上传需要导入的文件!' })
					}
				}
			})
		},

		$_submit() {
			this.$refs['batchStores'].validate(valid => {
				if (valid) {
					const self = this
					self.isLoading = true
				}
			})
		},
		$_cancle() {
			this.visible = false
			this.$emit('close')
		}
	},
	created() {
		if (Utils.data.get('horsemanImportMapping'+this.aid)) {
			const {
				platformKey,
				platformName,
				accessKey,
				accessName,
				brandId,
				brandName,
				emails
			} = Utils.data.get('horsemanImportMapping'+this.aid) || {}
			this.formData.brand = {
				platformKey: platformKey || '',
				platformName: platformName || '',
				brandId: brandId || 0,
				brandName: brandName || ''
			}
			this.formData.emails = emails || ''
			this.formData.accessKey = accessKey || ''
			this.formData.accessName = accessName || ''
		}
	},
	mounted() {
		this.visible = true
	},
	components: {
		SelectBrand,
		SelectAccess,
		SelectSys
	}
}
</script>

<style lang="scss" scoped>
.batch-stores__form {
	padding: {
		left: 20px;
	}
}
.content {
	padding: 20px 20px;
	color: #535353;
	.title {
		height: 32px;
		color: #384e8c;
		font-size: 14px;
		font-weight: 700;
	}
}
.filename__span {
	position: relative;
	font-size: 12px;
	width: 291px;
	vertical-align: middle;
	&.placeholder {
		color: #aaa;
	}
}
.select__btn,
.select-btn__span {
	margin-left: 8px;
}
.select-btn__span {
	display: inline-block;
	border-radius: 2px;
	background-color: #1895dd;
	min-width: 64px;
	height: 26px;
	text-align: center;
	line-height: 26px;
	white-space: nowrap;
	cursor: pointer;
	color: #fff;
}
.tips-txt {
	color: #ea2a2a;
	margin: {
		top: 8px;
	}
}
</style>
